import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Voucher, Product, ProductType, MotesPaths } from '../../models';
import { AutoSubOnDestroy, AutoSub, VoucherService, ProductService } from '../../providers';
import { UserRights, MotesLoginService } from '../../motes-login';


/**
 * Display voucher information and buy option with a card layout
 */
@AutoSubOnDestroy()
@Component({
    selector: 'mini-voucher',
    templateUrl: './mini-voucher.component.html',
    styleUrls: ['./mini-voucher.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MiniVoucherComponent implements OnInit {

    public product: Product = null;
    public productItems: string[] = [];
    public voucher: Voucher = null;
    public userRights: UserRights = null;
    public error: string = "";
    public expandCard: boolean = true;

    // Expose to view
    public ProductType = ProductType;

    @Input() withCardExpansion: boolean = false;
    @Input() disableCollapse: boolean = false;
    @Input() showTitleOverlay: boolean = true;
    @Input() index: number = null;
    @Input() clickable: boolean = false;
    @Output() userHasVoucher = new EventEmitter<boolean>();
    @Output() voucherCollapsed = new EventEmitter<Voucher>();

    @Input('product') set setProduct(product: Product) {
        this.updateProduct(product)

        AutoSub(this).reg['userRights'] = this.loginService.watchUserRights().pipe(switchMap((rights) => {
            this.userRights = rights; // ! Assigned but never used. Remove member variable
            // Check whether the user is logged in. If not, return empty observable
            if(!rights || !rights.uid) return EMPTY;
            // Otherwise, return an observable with the user's vouchers
            return this.voucherService.watchUserVouchers(rights.uid);
        })).subscribe((vouchers) => {
            // Sort vouchers (non redeemed first) and find first one that matches product key
            this.voucher = vouchers.sort((a, b) => a.redeemedOn - b.redeemedOn).find(v => v.productKey == this.product.key);
            // Check if any of the user vouchers gives access to the given product
            let accessToVoucher = vouchers.filter(voucher => voucher.productKey == this.product.key).length > 0;
            // Alert listeners about voucher affiliation with product
            this.userHasVoucher.emit(accessToVoucher);
        });
    };

    @Input('voucher') set setVoucher(voucher: Voucher) {
        this.voucher = voucher;

        AutoSub(this).reg['productSub'] = this.productService.watchProduct(this.voucher.productKey).subscribe((product) => {
            this.updateProduct(product);
        });
    };

    @Output('openVoucher') openVoucher = new EventEmitter<[Voucher, Product]>();

    constructor(private voucherService: VoucherService, private productService: ProductService, private loginService: MotesLoginService) { }

    ngOnInit() { }

    private updateProduct(product: Product) {
        this.product = product;
        this.productItems = this.product.shortText.split("\n");
    }

    public expandOrCollapse() {
        if(!this.withCardExpansion) return;
        this.expandCard = !this.expandCard;
        this.voucherCollapsed.emit(this.voucher);
    }

    public voucherClick() {
        this.openVoucher.emit([this.voucher, this.product]);
    }
}
